const linkLandingPagesES = {
    "view": {
        "table": {
            "title": "Tus páginas de destino de enlaces",
            "column": {
                "title": "Título",
                "description": "Descripción",
                "backUrl": "URL de regreso",
                "created": "Creado",
                "landingPage": "Página de destino",
                "action": "Acción"
            },
            "label": {
                "landingPage": "Página de destino"
            },
            "button": {
                "view": "Ver",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "message": {
                "linkCopied": "¡Enlace copiado al portapapeles!"
            }
        },
        "modal": {
            "edit": {
                "header": "¿Editar {{linkLandingPageName}}?",
                "body": "¿Estás seguro de que deseas editar esta página de destino de enlace?"
            },
            "delete": {
                "header": "¿Eliminar {{linkLandingPageName}}?",
                "body": "¿Estás seguro de que deseas eliminar esta página de destino de enlace?"
            }
        },
        "message": {
            "success": "¡La página de destino del enlace ha sido eliminada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "llpAllowanceSpent": "Has agotado tu asignación de páginas de destino de enlaces. Para crear más páginas de destino de enlaces, por favor mejora tu cuenta o contacta a nuestro equipo de soporte.",
            "subscriptionFeatureUnavailable": "Tu plan de suscripción actual no admite esta función. Por favor, <1>mejora</1> tu plan de suscripción para disfrutar de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "add": {
        "title": "Agregar página de destino de enlace",
        "form": {
            "label": {
                "domain": "Dominio",
                "title": "Título",
                "backUrl": "URL de regreso",
                "shortDescription": "Descripción corta",
                "logo": "Logo",
                "backgroundImage": "Imagen de fondo",
                "blurredBackground": "Fondo desenfocado",
                "blurred": "Desenfocado",
                "notBlurred": "No desenfocado",
                "blurStrength": "Intensidad de desenfoque",
                "layout": "Diseño",
                "font": "Fuente",
                "socialIconPlacement": "Ubicación del icono social",
                "socialIconColor": "Color del icono social",
                "buttonCorners": "Esquinas del botón",
                "buttonStyle": "Estilo del botón",
                "colorCustomisation": "Personalización de color",
                "premadeColors": "Colores predefinidos",
                "customColors": "Colores personalizados",
                "headerBackground": "Fondo del encabezado",
                "singleColor": "Color único",
                "gradient": "Gradiente",
                "bodyBackground": "Fondo del cuerpo",
                "titleColor": "Color del título",
                "descriptionColor": "Color de la descripción",
                "buttonColor": "Color del botón",
                "buttonTextColor": "Color del texto del botón",
                "backgroundColor": "Color de fondo"
            },
            "placeholder": {
                "domain": "Seleccionar dominio",
                "shortDescription": "Unas pocas palabras sobre tu página de destino. Máximo 80 caracteres"
            },
            "help_text": {
                "domain": "Selecciona el dominio para el cual deseas crear la página de destino de enlace.",
                "logo": "Sube formatos JPG o PNG, resolución al menos 500x500 px",
                "backgroundImage": "Sube formatos JPG o PNG, resolución de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Diseño Uno",
                    "layoutTwo": "Diseño Dos"
                },
                "socialIconPlacement": {
                    "header": "Encabezado",
                    "bottomOfTheBody": "Parte inferior del cuerpo"
                },
                "socialIconColor": {
                    "color": "Color",
                    "black": "Negro",
                    "white": "Blanco"
                },
                "buttonCorners": {
                    "rounded": "Redondeadas",
                    "semiRounded": "Semi redondeadas",
                    "squared": "Cuadradas"
                },
                "buttonStyle": {
                    "outlined": "Contorneado",
                    "filled": "Relleno"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "¡El formulario no puede ser enviado! Por favor, completa todos los campos y verifica los errores.",
                "storeUrlRequired": "Se requiere la URL de {{store}}",
                "storeUrlValid": "Por favor, añade una URL válida de {{store}}."
            }
        },
        "message": {
            "success": "¡La página de destino del enlace ha sido añadida!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "add": {
                "header": "¿Agregar página de destino {{title}}?",
                "body": "¿Estás seguro de que deseas crear una página de destino de enlace con el título {{title}}?"
            }
        }
    },
    "update": {
        "title": "Actualizar página de destino de enlace",
        "form": {
            "label": {
                "domain": "Dominio",
                "title": "Título",
                "backUrl": "URL de regreso",
                "shortDescription": "Descripción corta",
                "logo": "Logo",
                "backgroundImage": "Imagen de fondo",
                "blurredBackground": "Fondo desenfocado",
                "blurred": "Desenfocado",
                "notBlurred": "No desenfocado",
                "blurStrength": "Intensidad de desenfoque",
                "layout": "Diseño",
                "font": "Fuente",
                "socialIconPlacement": "Ubicación del icono social",
                "socialIconColor": "Color del icono social",
                "buttonCorners": "Esquinas del botón",
                "buttonStyle": "Estilo del botón",
                "colorCustomisation": "Personalización de color",
                "premadeColors": "Colores predefinidos",
                "customColors": "Colores personalizados",
                "headerBackground": "Fondo del encabezado",
                "singleColor": "Color único",
                "gradient": "Gradiente",
                "bodyBackground": "Fondo del cuerpo",
                "titleColor": "Color del título",
                "descriptionColor": "Color de la descripción",
                "buttonColor": "Color del botón",
                "buttonTextColor": "Color del texto del botón",
                "backgroundColor": "Color de fondo"
            },
            "placeholder": {
                "domain": "Seleccionar dominio",
                "shortDescription": "Unas pocas palabras sobre tu página de destino. Máximo 80 caracteres"
            },
            "help_text": {
                "domain": "Selecciona el dominio para el cual deseas crear la página de destino de enlace.",
                "logo": "Sube formatos JPG o PNG, resolución al menos 500x500 px",
                "backgroundImage": "Sube formatos JPG o PNG, resolución de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Diseño Uno",
                    "layoutTwo": "Diseño Dos"
                },
                "socialIconPlacement": {
                    "header": "Encabezado",
                    "bottomOfTheBody": "Parte inferior del cuerpo"
                },
                "socialIconColor": {
                    "color": "Color",
                    "black": "Negro",
                    "white": "Blanco"
                },
                "buttonCorners": {
                    "rounded": "Redondeadas",
                    "semiRounded": "Semi redondeadas",
                    "squared": "Cuadradas"
                },
                "buttonStyle": {
                    "outlined": "Contorneado",
                    "filled": "Relleno"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Otro"
                }
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "¡La página de destino del enlace ha sido actualizada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "update": {
                "header": "¿Actualizar página de destino {{title}}?",
                "body": "¿Estás seguro de que deseas actualizar la página de destino de enlace con el título {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Enlaces sociales",
        "label": {
            "order": "Orden",
            "platform": "Plataforma",
            "destinationUrl": "URL de destino"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Otro"
            }
        },
        "button": {
            "remove": "Eliminar",
            "add": "Agregar otro"
        }
    },
    "featuredLinksRow": {
        "title": "Enlaces destacados",
        "label": {
            "order": "Orden",
            "label": "Etiqueta",
            "destinationUrl": "URL de destino"
        },
        "button": {
            "remove": "Eliminar",
            "add": "Agregar otro"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Obteniendo análisis para el enlace de música"
        },
        "button": {
            "last7Days": "Últimos 7 días",
            "last14Days": "Últimos 14 días",
            "last30Days": "Últimos 30 días"
        },
        "linkLandingPageViews": {
            "title": "Vistas de la página de destino del enlace",
            "subtitle": "Vistas totales",
            "label": {
                "views": "Vistas"
            }
        },
        "socialLinkClicks": {
            "title": "Clics en enlaces sociales",
            "subtitle": "Clics totales",
            "table": {
                "column": {
                    "platform": "Plataforma",
                    "destinationUrl": "URL de destino",
                    "clicks": "Clics",
                    "clicksPct": "Clics (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Clics en enlaces destacados",
            "subtitle": "Clics totales",
            "table": {
                "column": {
                    "label": "Etiqueta",
                    "destinationUrl": "URL de destino",
                    "clicks": "Clics",
                    "clicksPct": "Clics (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Principales territorios",
            "subtitle": "Vistas totales",
            "table": {
                "column": {
                    "territory": "Territorio",
                    "views": "Vistas",
                    "viewsPct": "Vistas (%)"
                },
                "label": {
                    "otherTerritories": "Otros territorios"
                }
            }
        },
        "topBrowsers": {
            "title": "Principales navegadores",
            "subtitle": "Vistas totales",
            "table": {
                "column": {
                    "browser": "Navegador",
                    "views": "Vistas",
                    "viewsPct": "Vistas (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Principales tipos de dispositivos",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Principales sistemas operativos",
            "label": {
                "os": "Sistema operativo",
                "views": "Vistas"
            }
        }
    }
};

export default linkLandingPagesES;